import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { RouteComponentProps } from 'react-router';
import RoutePortal from "./RoutePortal";
import * as types from "../../constants/actionTypes";
import OurRoute from "./OurRoute";
import { authContext } from "../../adalConfig";

class RoutePortalLoggedIn extends OurRoute {

    componentDidMount() {
        this.componentWillUpdate();
    }

    componentWillUpdate(oldProps) {
        var isLoggedIn2 = (authContext.getCachedUser() !== null);
        if (this.state.match) {
            if (!this.props.isLoggedIn && !isLoggedIn2) {
                let params = '';
                //debugger;
                //Handling query params after logged in.
                if (this.props.location && this.props.location.search) {
                    params = this.props.location.search;
                }
                this.props.setRedirectUrl(this.state.match.url, params);
            }
        }
    }

    render() {
        var isLoggedIn2 = (authContext.getCachedUser() !== null);
        if (this.state.match) {
            if (this.props.isLoggedIn || isLoggedIn2) {
                if (!this.props.hasMyChart) {
                    // in the event that we don't have MyChart where we should, just go back to the root of the site
                    //debugger;
                    return <Redirect push to="/" />;
                }
                else {
                    return super.render();
                }
            }
            else {
                //alert("redering a redirect here");
                return <Redirect push to='/login' />;
            }
        }
        else {
            return "";
        }
    }

}


const mapStateToProps = (state, ownProps) => {
    return {
        isLoggedIn: state.domain.li, 
        hasMyChart: ownProps.RequireMyChart ? state.domain.hm : true
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRedirectUrl: (currentURL, params) => {
            //debugger;
            dispatch({ type: types.SET_REDIRECT_URL, URL: currentURL, params });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoutePortalLoggedIn);

